export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_52-b971975a478e9a5a8e02c7f33f4b66e6.jpg";